<img *ngIf="customPath && useCustom" [src]="customPath" [alt]="icon" class="print-custom-icon" (error)="onError()">
<i *ngIf="!customPath || !useCustom" [class]="'fas fa-' + icon"></i>
